module.exports = __webpack_public_path__ + "3bb3c35e5396a685011933a9b3c6b5dd.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-92@2x.png
// module id = 545
// module chunks = 0